import React from "react";
import { PDFImageProps } from "../../../utils/models";

import Conditional from "../../common/conditional";
import Input from "../input/input";

import classNames from './upload.module.scss';

interface Props {
    image: PDFImageProps;
    displayCaption: boolean;
    isImage: boolean;
    onEditImage: () => void;
    onReplaceImage: () => void;
    onDeleteImage: () => void;
    onUpdateCaption: (value: string) => void;
}

const UploadImage: React.FC<Props> = ({ displayCaption, isImage, image, onDeleteImage, onEditImage, onReplaceImage, onUpdateCaption }) => {
    return ( 
        <Conditional isVisible={isImage}>
            <div className={classNames['upload-preview-item']}>
                <div className={classNames['upload-preview-item-container']}>
                    <div className={classNames['upload-preview-item-actions']}>
                        <button
                            type="button"
                            className={classNames['upload-preview-item-actions-enlarge']}
                            onClick={onEditImage}
                        >
                            <i className="bi bi-pencil"></i>
                        </button>
                        
                        <button
                            type="button"
                            className={classNames['upload-preview-item-actions-replace']}
                            onClick={onReplaceImage}
                        >
                            <i className="bi bi-eraser"></i>
                        </button>

                        <button
                            type="button"
                            className={classNames['upload-preview-item-actions-delete']}
                            onClick={onDeleteImage}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>

                    <img
                        src={image.src}
                        alt={image.src}
                        className={classNames['upload-preview-item-img']}
                    />
                </div>


                <Conditional isVisible={displayCaption}>
                    <div className={classNames['upload-preview-item-caption']}>
                        <Input 
                            value={image.caption}
                            onChange={(event) => onUpdateCaption(event.target.value)}
                        />
                    </div>
                </Conditional>
            </div>
        </Conditional>
     );
};
 
export default UploadImage;